import React from "react";

import styles from "./InitialPageLoader.module.css";

function InitialPageLoader() {
  return (
    <div className={styles.overlay}>
      <div className={styles.loader}></div>
    </div>
  );
}

export default InitialPageLoader;
